import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  total_open_positions: {
    name: 'Total number of open positions',
    letter: 'A'
  }
};

export function OpenPositions({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.OPEN_POSITIONS,
    onChangeFund,
    schema: schema.OPEN_POSITIONS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.OPEN_POSITIONS?.field_names || [],
    tableName: 'OPEN_POSITIONS',
    columnLables,
    isMultiFunds,
    funds,
    order: 235 as any
  });

  return (
    <Table
      id="fca-reporttables-open-positions-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
